import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["appId", "privateListingsLink"],
  _excluded2 = ["appKey", "paymentModel", "buyLabel"],
  _excluded3 = ["artifactDownloadLink", "appId", "buildNumber"],
  _excluded4 = ["buyLabel", "hosting", "appKey", "buildNumber", "appId", "trialLicenseActivationLink", "artifactDownloadLink"],
  _excluded5 = ["appKey", "appId", "buildNumber", "licensePurchaseLink", "artifactDownloadLink", "hosting"],
  _excluded6 = ["learnMoreUrl"],
  _excluded7 = ["purchaseUrl"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/graphql-gateway-types';
import { log, MarketplaceAppUtils } from '@atlassian/mpac-utils';
import React, { useEffect } from 'react';
import { FREE_APP_CTA_LABEL_PRIMARY, FREE_APP_CTA_LABEL_SECONDARY, LEARN_MORE_CTA_LABEL, PAID_APP_CTA_LABEL_BUY, PAID_APP_CTA_LABEL_TRY, PURCHASE_CTA_LABEL } from '../../../../constants';
import { CTAKind, PurchaseIntent } from '../../AppListing.types';
import { CTAButton, FreeAppSubtext } from '../AppListingCTA.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const getPrimaryCTALabel = (paymentModel, buyLabel) => paymentModel === MarketplaceAppPaymentModel.Free ? FREE_APP_CTA_LABEL_PRIMARY : buyLabel || PAID_APP_CTA_LABEL_TRY;

// This should ideally never be rendered.
// Rendering of this button means that we do not know
// which button to render due to unhandled rendering logic
export function UnsupportedPrimaryCTA() {
  useEffect(() => {
    log.error('AppListingCTA', "Unhandled primary CTA button: don't know which button to render");
  }, []);
  return /*#__PURE__*/_jsx(FreeAppSubtext, {
    children: " Unsupported "
  });
}
export const PrivateListingCTA = _ref => {
  let {
      appId,
      privateListingsLink
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    _jsx(CTAButton, _objectSpread(_objectSpread({
      href: privateListingsLink.expand({
        appId
      })
    }, props), {}, {
      children: getPrimaryCTALabel(props.paymentModel, props.buyLabel)
    }))
  );
};
export const BitbucketCTA = _ref2 => {
  let {
      appKey,
      paymentModel,
      buyLabel
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return (
    /*#__PURE__*/
    _jsx(CTAButton, _objectSpread(_objectSpread({
      href: "https://bitbucket.org/site/addons/authorize?addon_key=".concat(appKey)
    }, props), {}, {
      children: getPrimaryCTALabel(paymentModel, buyLabel)
    }))
  );
};
export function ArtifactDownloadButton(_ref3) {
  let {
      artifactDownloadLink,
      appId,
      buildNumber
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded3);
  const artifactDownloadUrl = artifactDownloadLink.expand({
    appId,
    buildNumber
  });
  return (
    /*#__PURE__*/
    _jsx(CTAButton, _objectSpread(_objectSpread({
      href: artifactDownloadUrl
    }, props), {}, {
      children: FREE_APP_CTA_LABEL_PRIMARY
    }))
  );
}
export function TrialLicenseForm(_ref4) {
  let {
      buyLabel,
      hosting,
      appKey,
      buildNumber,
      appId,
      trialLicenseActivationLink,
      artifactDownloadLink
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded4);
  const hamsAppKey = MarketplaceAppUtils.toHAMSAppKey(appKey, hosting);
  const trialLicenseActivationUrl = trialLicenseActivationLink.expand({
    hamsAppKey
  });
  const artifactDownloadUrl = artifactDownloadLink.expand({
    appId,
    buildNumber
  });
  return /*#__PURE__*/_jsxs("form", {
    action: trialLicenseActivationUrl,
    method: "GET",
    children: [/*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "referrer",
      value: "pac"
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "binaryURL",
      value: artifactDownloadUrl
    }), /*#__PURE__*/_jsx(CTAButton, _objectSpread(_objectSpread({
      role: "link"
    }, props), {}, {
      type: "submit",
      children: buyLabel || PAID_APP_CTA_LABEL_TRY
    }))]
  });
}
export function LicensePurchaseForm(_ref5) {
  let {
      appKey,
      appId,
      buildNumber,
      licensePurchaseLink,
      artifactDownloadLink,
      hosting
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded5);
  const hamsAppKey = MarketplaceAppUtils.toHAMSAppKey(appKey, hosting);
  const licensePurchaseUrl = licensePurchaseLink.expand({
    hamsAppKey
  });
  const artifactDownloadUrl = artifactDownloadLink.expand({
    appId,
    buildNumber
  });
  return /*#__PURE__*/_jsxs("form", {
    action: licensePurchaseUrl,
    method: "POST",
    children: [/*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "referrer",
      value: "pac"
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "binaryURL",
      value: artifactDownloadUrl
    }), /*#__PURE__*/_jsx(CTAButton, _objectSpread(_objectSpread({
      role: "link"
    }, props), {}, {
      type: "submit",
      children: PAID_APP_CTA_LABEL_BUY
    }))]
  });
}
export function LearnMoreCTA(_ref6) {
  let {
      learnMoreUrl
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return (
    /*#__PURE__*/
    _jsx(CTAButton, _objectSpread(_objectSpread({
      href: learnMoreUrl,
      target: "_blank"
    }, props), {}, {
      children: LEARN_MORE_CTA_LABEL
    }))
  );
}
export function PurchaseCTA(_ref7) {
  let {
      purchaseUrl
    } = _ref7,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return (
    /*#__PURE__*/
    _jsx(CTAButton, _objectSpread(_objectSpread({}, props), {}, {
      target: "_blank",
      href: purchaseUrl,
      children: PURCHASE_CTA_LABEL
    }))
  );
}
export const getGenericCloudCTAs = props => {
  const primaryIntent = props.paymentModel === MarketplaceAppPaymentModel.Free ? PurchaseIntent.GET : PurchaseIntent.TRY;
  return {
    PrimaryCTA(ctaOverrides) {
      return (
        /*#__PURE__*/
        _jsx(CTAButton, _objectSpread(_objectSpread({
          onClick: e => props.onClick(e, primaryIntent),
          autoFocus: props.autoFocus,
          shouldFitContainer: props.shouldFitContainer,
          ctaSubtext: props.paymentModel === MarketplaceAppPaymentModel.Free ? FREE_APP_CTA_LABEL_SECONDARY : undefined
        }, ctaOverrides), {}, {
          children: getPrimaryCTALabel(props.paymentModel, ctaOverrides.buyLabel)
        }))
      );
    },
    SecondaryCTA() {
      return null;
    }
  };
};
export function getArtifactOrLearnMoreCTAs(ctaProps) {
  let PrimaryCTA;
  let SecondaryCTA;
  const {
    learnMoreUrl,
    purchaseUrl,
    buildNumber,
    paymentModel
  } = ctaProps.appVersion || {};
  if (purchaseUrl) {
    // eslint-disable-next-line react/display-name
    SecondaryCTA = ctaOverrides => /*#__PURE__*/_jsx(PurchaseCTA, _objectSpread({
      purchaseUrl: purchaseUrl,
      appearance: "link",
      onClick: e => ctaProps.onClick(e, PurchaseIntent.GET, CTAKind.SECONDARY)
    }, ctaOverrides));
  } else if (learnMoreUrl) {
    // eslint-disable-next-line react/display-name
    SecondaryCTA = ctaOverrides => /*#__PURE__*/_jsx(LearnMoreCTA, _objectSpread({
      appearance: "link",
      learnMoreUrl: learnMoreUrl,
      onClick: e => ctaProps.onClick(e, PurchaseIntent.GET, CTAKind.SECONDARY)
    }, ctaOverrides));
  }
  if (ctaProps.binaryAvailable) {
    // eslint-disable-next-line react/display-name
    PrimaryCTA = ctaOverrides => /*#__PURE__*/_jsx(ArtifactDownloadButton, _objectSpread({
      appId: ctaProps.appId,
      buildNumber: buildNumber,
      artifactDownloadLink: ctaProps.artifactDownloadLink,
      autoFocus: ctaProps.autoFocus,
      onClick: e => ctaProps.onClick(e, PurchaseIntent.GET, CTAKind.PRIMARY),
      ctaSubtext: paymentModel === MarketplaceAppPaymentModel.Free ? FREE_APP_CTA_LABEL_SECONDARY : undefined
    }, ctaOverrides));
  } else if (learnMoreUrl) {
    // eslint-disable-next-line react/display-name
    PrimaryCTA = ctaOverrides => /*#__PURE__*/_jsx(LearnMoreCTA, _objectSpread({
      appearance: "primary",
      learnMoreUrl: learnMoreUrl,
      autoFocus: ctaProps.autoFocus,
      onClick: e => ctaProps.onClick(e, PurchaseIntent.GET, CTAKind.PRIMARY),
      ctaSubtext: paymentModel === MarketplaceAppPaymentModel.Free ? FREE_APP_CTA_LABEL_SECONDARY : undefined
    }, ctaOverrides));
    if (!purchaseUrl) {
      // Secondary CTA was set to learn more too
      SecondaryCTA = null;
    }
  } else if (purchaseUrl) {
    // eslint-disable-next-line react/display-name
    PrimaryCTA = ctaOverrides => /*#__PURE__*/_jsx(PurchaseCTA, _objectSpread({
      purchaseUrl: purchaseUrl,
      appearance: "primary",
      autoFocus: ctaProps.autoFocus,
      onClick: e => ctaProps.onClick(e, PurchaseIntent.GET, CTAKind.PRIMARY),
      ctaSubtext: paymentModel === MarketplaceAppPaymentModel.Free ? FREE_APP_CTA_LABEL_SECONDARY : undefined
    }, ctaOverrides));
    SecondaryCTA = null; // Secondary CTA was set to purchase too
  } else {
    PrimaryCTA = UnsupportedPrimaryCTA;
  }
  return {
    PrimaryCTA,
    SecondaryCTA
  };
}